import { render, staticRenderFns } from "./EditerRight.vue?vue&type=template&id=4970eef6&scoped=true"
import script from "./EditerRight.vue?vue&type=script&lang=js"
export * from "./EditerRight.vue?vue&type=script&lang=js"
import style0 from "./EditerRight.vue?vue&type=style&index=0&id=4970eef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970eef6",
  null
  
)

export default component.exports